/* unplugin-vue-components disabled */import script from "./addClientDailog.vue?vue&type=script&setup=true&lang=js"
export * from "./addClientDailog.vue?vue&type=script&setup=true&lang=js"

import "./addClientDailog.vue?vue&type=style&index=0&id=773883dc&lang=scss&scoped=true"
import "./addClientDailog.vue?vue&type=style&index=1&id=773883dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773883dc"]])

export default __exports__